// src/components/ModuleModal/ModuleModal.tsx
// Shell สำหรับทุก module — เปิดเป็น fullscreen modal
// เมื่อปิด => unmount children (ลบข้อมูลออก) เมื่อเปิด => mount ใหม่ (โหลดใหม่)

import React from 'react'
import { Modal } from 'react-bootstrap'

interface Props {
  show: boolean
  title: string
  icon?: string
  onClose: () => void
  children: React.ReactNode
  size?: 'sm' | 'lg' | 'xl'
  fullscreen?: boolean | 'sm-down' | 'md-down' | 'lg-down' | 'xl-down' | 'xxl-down'
}

export default function ModuleModal({
  show,
  title,
  icon,
  onClose,
  children,
  fullscreen = true,
}: Props) {
  return (
    <Modal
      show={show}
      onHide={onClose}
      fullscreen={fullscreen || undefined}   // false → undefined (ไม่ส่ง prop)
      backdrop='static'
      scrollable
    >
      <Modal.Header
        closeButton
        style={{
          borderBottom: '2px solid #ffc107',
          padding: '10px 16px',
          backgroundColor: '#fff',
        }}
      >
        <Modal.Title style={{ fontSize: 15, fontWeight: 700 }}>
          {icon && <i className={`${icon} me-2`} style={{ color: '#ffc107' }} />}
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: 0, backgroundColor: '#f8f9fa' }}>
        {/* mount/unmount ตาม show — ทำให้ทุกครั้งที่เปิดจะ fetch ใหม่ */}
        {show && children}
      </Modal.Body>
    </Modal>
  )
}
